import React from "react";
import { Field, FieldInputProps, ErrorMessage } from "formik";
import InputWithIcon from "../../../components/input/input";
import { useTranslation } from "react-i18next";

interface Props {
  businessAgentsValue: boolean;
  setBusinessAgentsValue: (v: boolean) => void;
}

const StepHowDidYouKnow: React.FC<Props> = ({
  businessAgentsValue,
  setBusinessAgentsValue,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <p>{t("how-about-our-system")}</p>

      <label>
        <Field type="checkbox" name="options_about[]" value={t("radio")} />{" "}
        {t("radio")}
      </label>
      <br />
      <label>
        <Field type="checkbox" name="options_about[]" value={t("tv")} />{" "}
        {t("tv")}
      </label>
      <br />
      <label>
        <Field
          type="checkbox"
          name="options_about[]"
          value={t("social-network")}
        />{" "}
        {t("social-network")}
      </label>
      <br />
      <label>
        <Field
          type="checkbox"
          name="options_about[]"
          value={t("business-agents")}
          onChange={() => setBusinessAgentsValue(!businessAgentsValue)}
        />{" "}
        {t("business-agents")}
      </label>

      {!businessAgentsValue && (
        <div className="mt-2">
          <Field name="business_agents_name">
            {({ field }: { field: FieldInputProps<any> }) => (
              <InputWithIcon
                icon={""}
                iconSize="19px"
                field={field}
                placeholder={t("name")}
              />
            )}
          </Field>
          <ErrorMessage name="business_agents_name" />
        </div>
      )}
    </>
  );
};

export default StepHowDidYouKnow;
